import { AppBar, Avatar, Box, Container, IconButton, Link, Menu, MenuItem, MenuList, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu'

const NavBarMUI = () => {

    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value)
    };

    const [anchorElNav, setAnchorElNav] = useState(null);
    // const [anchorElUser, setAnchorElUser] = useState(null);
  
    const handleOpenNavMenu = (e) => {
      setAnchorElNav(e.currentTarget);
    };
  
    const handleCloseNavMenu = (e) => {
      setAnchorElNav(null);
    };

    useEffect(() => {
      const onScroll = () => {
        if (window.scrollY > 30) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
      }
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    

  return (
    <div >
        <AppBar position='fixed' className={scrolled ? `${'scrolled'}` : `${'not-scrolled'}`} 
            sx={{backgroundColor: "#0c215a"}}
        >
            <Container>
                <Toolbar disableGutters
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center"}} >
                        <IconButton>
                            <Avatar src='/images/aniekanprofile-bg.png' alt='profile' />
                        </IconButton>
                        <Typography variant='h5' noWrap component='a' href='/'
                            style={{fontSize: '24px', lineHeight: '32px', fontStyle: 'normal', letterSpacing: '0.25px', fontWeight: '700', color: '#fff', cursor: 'pointer', marginLeft: '20px'}}
                        >
                            Aniekan Edet
                        </Typography>
                    </Box>
                    <Box sx={{fontSize: "16px", color: "#fff", textDecoration: "none", flexGrow: 0,
                        display: {xs: "none", md: "flex",},
                        flexDirection: {xs: 'column', md: 'row',},
                        justifyContent: {xs: 'center', md: 'end',},
                        alignContent: {xs: '', md: ''},
                        alignItems: {xs: 'start',md: 'center',},
                        width: "100%"}}
                    >
                        <div className={`${'social-icon'}`}>
                            <a href='https://www.linkedin.com/in/aniekan-edet-03521a96/' target='_blank' rel='noreferrer'>
                            <img src='/images/nav-icon1.svg' alt='facebook-link' />
                            </a>
                            <a href='https://web.facebook.com/AniekangEdet' target='_blank' rel='noreferrer'>
                            <img src='/images/nav-icon2.svg' alt='linkedIn-link' />
                            </a>
                            <a href='http://www.twitter.com/agedet9060' target='_blank' rel='noreferrer'>
                            <img src='/images/nav-icon4.svg' alt='twitter-link' />
                            </a>
                            <a href='http://www.github.com/agedet' target='_blank' rel='noreferrer'>
                            <img src='/images/nav-icon6.svg' alt='twitter-link' />
                            </a>
                        </div>
                        <Link href='#home' 
                            sx={{color: "inherit", textDecoration: "inherit", marginLeft: "50px"}}
                            className={activeLink === 'home' ? 'activeLink navbar-link' : 'navbar-link'}
                            onClick={() => {onUpdateActiveLink('home')}}
                        >
                            Home
                        </Link>
                        <Link href='#project' 
                            sx={{color: "inherit", textDecoration: "inherit", marginLeft: "50px"}}
                            className={activeLink === 'project' ? 'activeLink navbar-link' : 'navbar-link'}
                            onClick={() => {onUpdateActiveLink('project')}}
                        >
                            Project
                        </Link>
                        <Link 
                            href='https://drive.google.com/file/d/1ixeVMgpcuYVVnE_iktjIRQe1sWMPBRZi/view?usp=sharing' 
                            target='_blank'
                            sx={{color: "inherit", textDecoration: "inherit", marginLeft: "50px"}}
                            className={activeLink === 'resume' ? 'activeLink navbar-link' : 'navbar-link'}
                            onClick={() => {onUpdateActiveLink('resume')}}
                        >
                            Resume
                        </Link>
                        <Link href='#contact' 
                            sx={{
                                color: "inherit", textDecoration: "inherit",
                                marginLeft: "50px"
                            }}
                            className={activeLink === 'contact' ? 'activeLink navbar-link' : 'navbar-link'}
                            onClick={() => {onUpdateActiveLink('contact')}}
                        >
                            Contact
                        </Link>
                    </Box>

                    {/* Nav menu */}
                    <Box 
                        sx={{
                            display: {
                                xs: "block",
                                // sm: "none",
                                md: "none",
                            },
                        }}
                    >
                        {/* Nav Menu Button */}
                        <IconButton
                            size='large'
                            onClick={handleOpenNavMenu}
                            aria-controls='menu-appbar'
                            aria-haspopup= 'true'
                            sx= {{
                              display: { 
                                xs: 'block', 
                                md: 'none',
                              },
                            }}
                        >
                            <MenuIcon style={{ fontSize: '40px', color: '#fff'}} />
                        </IconButton>
                        {/* Nav Menu */}

                        <Menu
                            id= 'menu-appbar'
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            keepMounted transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {
                                  xs: 'block', 
                                  md: 'none'
                                },  
                                width: '100%' ,
                                // backgroundColor: '#fff',
                                // opacity: 0.55     
                            }}
                        >
                            <MenuList>
                                <MenuItem onClick={handleCloseNavMenu}
                                    sx={{backgroundColor: '#fff', padding: '20px 100px', textAlign: 'center'}}
                                >
                                    <Link href='#home'
                                        variant='subtitle2'
                                        sx={{
                                            color: '#222330', 
                                            display: 'block', 
                                            fontWeight: '700',
                                            textTransform: 'captitalise',
                                            textDecoration: 'none',
                                            fontSize: '18px',
                                        }}
                                    >
                                        Home
                                    </Link>
                                </MenuItem>
                                <MenuItem onClick={handleCloseNavMenu}
                                    sx={{backgroundColor: '#fff', padding: '20px 100px'}}
                                >
                                    <Link href='#project'
                                        variant='subtitle2'
                                        sx={{
                                            color: '#222330', 
                                            display: 'block', 
                                            fontWeight: 700,
                                            textTransform: 'capitalise',
                                            textDecoration: 'none',
                                            fontSize: '18px',
                                        }}
                                    >
                                        Projects
                                    </Link>
                                </MenuItem>
                                <MenuItem onClick={handleCloseNavMenu}
                                    sx={{backgroundColor: '#fff', padding: '20px 100px'}}
                                >
                                    <Link href='https://drive.google.com/file/d/1ixeVMgpcuYVVnE_iktjIRQe1sWMPBRZi/view?usp=sharing'
                                        variant='subtitle2'
                                        sx={{
                                            color: '#222330', 
                                            display: 'block', 
                                            fontWeight: '700',
                                            textTransform: 'capitalise',
                                            textDecoration: 'none',
                                            fontSize: '18px',
                                        }}
                                    >
                                        Resume
                                    </Link>
                                </MenuItem>
                                <MenuItem onClick={handleCloseNavMenu}
                                     sx={{backgroundColor: '#fff', padding: '20px 100px'}}
                                >
                                    <Link href='#contact'
                                        variant='subtitle2'
                                        sx={{ 
                                            color: '#222330', 
                                            display: 'block', 
                                            fontWeight: '700',
                                            textTransform: 'capitalise',
                                            textDecoration: 'none',
                                            fontSize: '18px',
                                        }}
                                    >
                                        Contact
                                    </Link>
                                </MenuItem>
                            </MenuList>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    </div>
  )
}

export default NavBarMUI